<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <es-header >
          <template #header>
            <div class="header-title">Search Results</div>
          </template>
          <template #actions>
            <ul>
              <li class="p-narrow no-border">
                <div class="list-content">
                  <div class="has-text-weight-bold is-size-5">{{ totalResults }}</div>
                  <div>Results</div>
                </div>
              </li>
            </ul>
          </template>
        </es-header>
      </div>
      <div class="summary-container">
        <div class="columns is-mobile">
          <div class="column is-1-mobile">
          </div>
          <div class="column">
            <div class="column-container">
              <div>
                <es-match/>
              </div>
              <div class="block">
                <div class="has-text-weight-bold is-size-5">
                  {{ this.numberMatches}}
                </div>
                <div>
                  Matches
                </div>
              </div>
            </div>
          </div>
          <div class="column has-left-border">
            <div class="column-container">
              <div>
                <es-near-match/>
              </div>
              <div class="block">
                <div class="has-text-weight-bold is-size-5">
                  {{ this.numberNearMatches}}
                </div>
                <div>
                  Near Matches
                </div>
              </div>
            </div>
          </div>
          <div class="column is-1-mobile">
          </div>
        </div>
      </div>
    </div>
    <es-loader v-if="this.loading === true"/>
    <es-data-card v-else :matchResults="searchResults"/>
    <!-- TODO no results -->
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown,
  faCaretUp,
} from '@fortawesome/pro-solid-svg-icons';
import EsDataCard from '@/components/EsDataCard.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsMatch from '@/components/EsMatch.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

library.add(
  faCaretDown,
  faCaretUp,
);

export default {
  mixins: [BreadcrumbsManager],
  components: {
    EsDataCard,
    EsHeader,
    EsLoader,
    EsMatch,
    EsNearMatch,
  },
  data() {
    return {
      loading: false,
      matches: [],
      searchSource: null,
      searchResults: [],
      numberMatches: 0,
      numberNearMatches: 0,
      totalResults: null,
      idType: null,
      id: null,
      name: null,
      street1: null,
      street2: null,
      city: null,
      state: null,
      zip: null,
    };
  },
  created() {
    this.setBreadcrumb([
      { text: 'Location Group', to: { name: 'groupList' } },
      { text: 'Search Options', to: { } },
    ]);
  },
  mounted() {
    this.doSearch();
  },
  methods: {
    getNumberMatches(results) {
      this.numberMatches = results.matchesCount;
      this.numberNearMatches = results.nearMatchCount;
      this.totalResults = results.totalResults;
    },
    async doSearch() {
      const { query } = this.$route;
      this.searchSource = query.searchSource;

      this.toggleLoading();

      // Id Search
      if (this.searchSource === 'idSearch') {
        this.id = query.id;
        this.idType = query.idType;

        // Local Code || State Location Id
        const idType = (query.idType === 'locationId') ? 'locationId' : 'localCode';

        try {
          const res = await axios.post(`search/location?id=${this.id}&idType=${idType}`);
          this.searchResults = res.data;
        } catch (err) {
          // console.error(err);
        }
      } else if (this.searchSource === 'advancedSearch' || this.searchSource === 'navbarSearch') {
        this.name = query.name;
        this.street1 = query.street1;
        this.street2 = query.street2;
        this.city = query.city;
        this.state = query.state;
        this.zip = query.zip;

        try {
          const res = await axios.post('/search/location', ({
            name: this.name,
            street1: this.street1,
            street2: this.street2,
            city: this.city,
            stateCode: this.state,
            zip: this.zip,
          }));
          this.searchResults = res.data;
        } catch (err) {
          // console.error(err);
        }
      }

      this.toggleLoading();
      this.getNumberMatches(this.searchResults);
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
  },
  watch: {
    $route: 'doSearch',
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 1168px
    margin-bottom: 30px

  .summary-container
    padding: .5rem 1rem
  .columns
    margin: 0
    height: 100%
    .column
      padding: 0 .5rem
      .column-container
        display: flex
        flex-direction: row
        justify-content: center
        height: 100%
        .block
          display: flex
          flex-direction: column
          justify-content: center
          height: 100%

  .numbers
    text-align: center
  .has-left-border
    border-left: 1px solid  rgb(222, 226, 230)

</style>
